import { Component, OnInit } from '@angular/core';
import { ChatBroadcaster } from 'src/app/services/chat-broadcaster/chat-broadcaster';
import { BroadcasterEvent } from 'src/app/models/broadcaster-events.enum';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {

  showError = false;
  errorText = '';

  constructor(private broadcaster: ChatBroadcaster)
  {
    this.broadcaster.on(BroadcasterEvent.EVENT_SHOW_CHAT_ERROR)
    .subscribe((errorText: string) =>
      {
        this.showError = true;
        this.errorText = errorText;
      });
  }

  ngOnInit()
  {
  }

  shouldShowError()
  {
    return this.showError;
  }

  getErrorText()
  {
    return this.errorText;
  }

  closeBtnAction()
  {
    this.showError = false;
  }
}
